// src/axios/services/puntointeres.js
import BaseService from "./baseService";

const balnearioService = new BaseService("punto-interes");

export default balnearioService;
